import { BaseUpload } from 'craftable';

Vue.component('media-upload', {
    mixins: [BaseUpload]
});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/app-components/Form/AppUpload.js